var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowShieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.262 3.30902V8.39261C15.262 13.0222 12.1181 17.0591 7.62726 18.1959C3.14394 17.0628 0 13.0222 0 8.39261V3.30902C3.53037 2.91134 5.53004 1.56822 7.63101 0C9.73197 1.56822 11.7316 2.91134 15.262 3.30902Z",
    fill: "#FFD15C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63036 16.1887C4.25005 15.1157 1.92773 11.9792 1.92773 8.39259V4.9485C4.30258 4.43077 6.04713 3.47408 7.63036 2.38232C9.24735 3.50409 10.9581 4.44202 13.333 4.95226V8.39634C13.333 11.9792 11.0107 15.1157 7.63036 16.1887Z",
    fill: "#F8B64C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36497 12.208L4.48535 10.3284L5.43829 9.37168L6.36497 10.2946L9.8203 6.84302L10.7732 7.79596L6.36497 12.208Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowShieldIcon);
export default __webpack_public_path__ + "static/media/yellow-shield-icon.82afd4e4ab7a60287e0ff56ef5e63cb5.svg";
export { ForwardRef as ReactComponent };